define('AwaLabs.DynamicMerchandisingZones', [
    'MerchandisingZoneSliders',
    'Item.Collection',
    'Merchandising.View',
    'ItemRelations.RelatedItem.View',
    'Configuration',
    'Backbone',
    'underscore',
    'Utils',
    'jQuery',
    'awalabs_dynamicmerchandisingzones.tpl',
    'merch_item.tpl'
], function DynamicMerchandisingZone(
    MerchandisingZoneSliders,
    ItemCollection,
    MerchandisingView,
    ItemRelationsRelatedItemView,
    Configuration,
    Backbone,
    _,
    Utils,
    jQuery,
    awalabsDynamicmerchandisingzones,
    merchItemTpl
) {
    'use strict';

    Configuration = Configuration.Configuration || Configuration;

    var layoutMountKey = 'awaLabsDynamicMerchandisingZonesMounted';
    var placeholderViewKey = 'awaLabsDynamicMerchandisingZoneView';

    var loadTpl = function loadTplIntoView(view, tplName) {
        var tplFn;

        if (tplName) {
            // we try to get the 'template' from the merchandising rule
            try {
                tplFn = Utils.requireModules(tplName + '.tpl');
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Template ' + tplName + ' is not compiled into the application, using default');
            }
            if (tplFn) {
                view.template = tplFn;
            } else {
                view.template = awalabsDynamicmerchandisingzones;
            }
        } else {
            view.template = awalabsDynamicmerchandisingzones;
        }
    };

    if (!ItemRelationsRelatedItemView.prototype.awaLabsDynamicMerchandisingContext) {
        ItemRelationsRelatedItemView.prototype.getContext = _.wrap(
            ItemRelationsRelatedItemView.prototype.getContext,
            function wrapContext(fn) {
                var merchandisingView = this.parentView && this.parentView.parentView;

                if (merchandisingView &&
                    merchandisingView.options &&
                    merchandisingView.options.isMerchant &&
                    Configuration.get('cms.useGrid')) {
                    this.template = merchItemTpl;
                }
                return fn.apply(this, _.toArray(arguments).slice(1));
            }
        );
        ItemRelationsRelatedItemView.prototype.awaLabsDynamicMerchandisingContext = true;
    }

    return {
        mountToApp: function mountToApp(application) {
            var Layout = application.getLayout();
            var onMerchandisingZoneRender;
            var onAfterAppendView;
            var ownedViews = [];
            var zones = [];
            var disposed = false;

            if (!Layout || Layout[layoutMountKey]) {
                return;
            }
            Layout[layoutMountKey] = true;
            this.application = application;

            function pageKey() {
                return typeof window !== 'undefined' && window.location
                    ? window.location.pathname + window.location.search + window.location.hash
                    : '';
            }

            function destroyView(view) {
                if (view && typeof view.destroy === 'function') view.destroy(true);
                ownedViews = _.without(ownedViews, view);
            }

            function bindingFor(placeholder) {
                var cct = placeholder.closest && placeholder.closest('[data-cms-cct-instanceid]');
                var area = cct && cct.closest('[data-cms-area]');
                var node = placeholder;
                var path = [];

                if (!cct || !area) return null;
                while (node !== cct) {
                    if (!node.parentElement) return null;
                    path.unshift(Array.prototype.indexOf.call(node.parentElement.children, node));
                    node = node.parentElement;
                }
                return {
                    cct: cct.getAttribute('data-cms-cct-instanceid'),
                    area: area.getAttribute('data-cms-area'),
                    filters: area.getAttribute('data-cms-area-filters'),
                    path: path,
                    tag: placeholder.tagName
                };
            }

            function resolvePlaceholder(options, binding) {
                var placeholder = options && options.divId && typeof document !== 'undefined'
                    ? document.getElementById(String(options.divId)) : null;
                var candidates;
                var target;
                var currentBinding;
                var wrappedCmsSlot = false;

                if (placeholder && Layout.el &&
                    (placeholder === Layout.el || jQuery.contains(Layout.el, placeholder))) {
                    if (binding && JSON.stringify(bindingFor(placeholder)) !== JSON.stringify(binding)) return null;
                    return placeholder;
                }
                if (!binding || !Layout.el || !Layout.el.querySelectorAll) return null;

                // CMS recreates an empty CCT without its generated merchzone ID
                // when Home re-renders. Restore only the same owned, empty slot.
                candidates = Array.prototype.slice.call(
                    Layout.el.querySelectorAll('[data-cms-cct-instanceid]')
                ).filter(function matchesCct(cct) {
                    var area = cct.closest('[data-cms-area]');
                    return cct.getAttribute('data-cms-cct-instanceid') === binding.cct && area &&
                        area.getAttribute('data-cms-area') === binding.area &&
                        area.getAttribute('data-cms-area-filters') === binding.filters;
                });
                if (candidates.length !== 1) return null;
                target = candidates[0];
                binding.path.forEach(function descend(index) {
                    target = target && target.children[index];
                });
                // CMS initially emits its generated zone directly in the CCT,
                // then wraps it as HTML content. A fresh Home template instead
                // contains the raw #cms > empty div slot. Accept only that exact
                // native wrapper transition; never replace arbitrary CCT HTML.
                if (binding.path.length === 1 && binding.path[0] === 0 && target &&
                    target.parentElement === candidates[0] && target.id === 'cms' &&
                    target.children.length === 1 && target.firstElementChild.tagName === binding.tag) {
                    target = target.firstElementChild;
                    wrappedCmsSlot = true;
                }
                if (!target || target.tagName !== binding.tag || target.id ||
                    target.children.length || String(target.textContent || '').trim()) return null;
                currentBinding = bindingFor(target);
                if (wrappedCmsSlot && currentBinding) currentBinding.path = binding.path;
                if (JSON.stringify(currentBinding) !== JSON.stringify(binding)) return null;
                // Never create a duplicate ID or take over another layout's node.
                if (document.getElementById(String(options.divId))) return null;
                target.id = String(options.divId);
                return target;
            }

            function appendZone(itemsData, options, owner, route, cached) {
                if (disposed || owner !== Layout.currentView || route !== pageKey()) return;
                var placeholder = resolvePlaceholder(options, cached && cached.binding);
                var isOwnedPlaceholder = placeholder && Layout.el &&
                    (placeholder === Layout.el || jQuery.contains(Layout.el, placeholder));
                var $placeHolder = isOwnedPlaceholder ? jQuery(placeholder) : jQuery();
                var previousView;
                var collection;
                var view;
                var containerTpl;
                var binding;
                var snapshot = null;

                if (!$placeHolder.length) {
                    return;
                }

                binding = bindingFor(placeholder);
                zones = zones.filter(function retainOtherZone(zone) {
                    var sameSlot = zone.options.divId === options.divId ||
                        (binding && JSON.stringify(zone.binding) === JSON.stringify(binding));
                    if (!sameSlot) return true;
                    destroyView(zone.view);
                    return false;
                });
                previousView = $placeHolder.data(placeholderViewKey);
                if (previousView && ownedViews.indexOf(previousView) >= 0) destroyView(previousView);
                // CMS data is JSON. Snapshot before Item.Collection parses it;
                // replay the original response shape, including its items key.
                try { snapshot = JSON.parse(JSON.stringify(itemsData)); } catch (error) {}

                collection = new ItemCollection(itemsData, {parse: true});
                view = new MerchandisingView({
                    items: collection,
                    model: new Backbone.Model({
                        show: Infinity
                    }),
                    isMerchant: true
                });
                containerTpl = $placeHolder.closest('[data-cms-area]').data('template');

                loadTpl(view, containerTpl || options.tpl);

                view.setElement($placeHolder[0]);
                view.render();
                $placeHolder.data(placeholderViewKey, view);
                ownedViews.push(view);
                view.trigger('afterMerchandAppendToDOM');
                zones.push({
                    itemsData: snapshot,
                    options: _.extend({}, options),
                    owner: owner,
                    route: route,
                    binding: binding,
                    view: view,
                    renderedChild: placeholder.firstElementChild
                });
            }

            onMerchandisingZoneRender = function onMerchandisingZoneRender(itemsData, options) {
                var owner = Layout.currentView;
                var route = pageKey();
                _.defer(function deferredAppend() {
                    appendZone(itemsData, options, owner, route);
                });
            };

            onAfterAppendView = function restoreMerchandisingZones(view) {
                if (view && Layout.currentView && view !== Layout.currentView) return;
                _.defer(function replayOwnedZones() {
                    if (disposed) return;
                    zones.slice().forEach(function restoreZone(zone) {
                        var placeholder;
                        if (zone.owner !== Layout.currentView || zone.route !== pageKey()) {
                            destroyView(zone.view);
                            zones = _.without(zones, zone);
                            return;
                        }
                        if (!zone.itemsData) return;
                        placeholder = resolvePlaceholder(zone.options, zone.binding);
                        if (!placeholder) return;
                        if (zone.view.el === placeholder && zone.renderedChild &&
                            placeholder.contains(zone.renderedChild)) return;
                        zone.binding = bindingFor(placeholder) || zone.binding;
                        appendZone(zone.itemsData, zone.options, zone.owner, zone.route, zone);
                    });
                });
            };

            Backbone.Events.on('cms:custom:merchzone-rendered', onMerchandisingZoneRender);
            Layout.on('afterAppendView', onAfterAppendView);
            Layout.once('destroy', function removeDynamicMerchandisingZoneListener() {
                disposed = true;
                Backbone.Events.off('cms:custom:merchzone-rendered', onMerchandisingZoneRender);
                Layout.off('afterAppendView', onAfterAppendView);
                _.each(ownedViews, function destroyOwnedView(view) {
                    if (view && typeof view.destroy === 'function') {
                        view.destroy(true);
                    }
                });
                ownedViews = [];
                zones = [];
                delete Layout[layoutMountKey];
            });
        }
    };
});
